<template>
  <RkTable class="major-table" :data="sliceShareholderList" :loading="loading" :finished="finished">
    <template #footer>
      <ShowMoreButton v-if="shareholderList.length > 5" v-model="isMore" />
    </template>
    <RkTableColumn prop="holderName" label="股东名称" fixed align="left" :width="`${postcssPatch(100)}`">
      <template #default="{ row }">{{ $digitjs(row.holderName).isNull() }}</template>
    </RkTableColumn>
    <RkTableColumn prop="holdingNumber" label="持股数量" :width="`${postcssPatch(80)}`">
      <template #default="{ row }">{{ $digitjs(row.holdingNumber).convert() }}</template>
    </RkTableColumn>
    <RkTableColumn prop="holdingRatio" label="持股比例" :width="`${postcssPatch(80)}`">
      <template #default="{ row }">{{ $digitjs(row.holdingRatio).unit('%').rounded() }}</template>
    </RkTableColumn>
    <RkTableColumn prop="changeNumber" label="变动股数" :width="`${postcssPatch(115)}`">
      <template #default="{ row }">
        <span>
          {{ $digitjs(row.changeNumber).prefix().convert() }}
        </span>
        <i
          v-if="row.changeNumber < 0"
          class="iconfont icon-xiangxiajiantoucuxiao"
          :style="{ color: theme['--down-color'] }"
        ></i>
        <i
          v-if="row.changeNumber > 0"
          class="iconfont icon-xiangshangjiantoucuxiao"
          :style="{ color: theme['--up-color'] }"
        ></i>
      </template>
    </RkTableColumn>
  </RkTable>
</template>

<script>
import ShowMoreButton from '@/components/common/ShowMoreButton.vue'
import { postcssPatch } from '@/utils/postcssPatch'
export default {
  components: { ShowMoreButton },
  inject: ['theme'],
  props: ['total'],
  data() {
    return {
      loading: false,
      finished: false,
      isMore: false,
      shareholderList: []
    }
  },
  computed: {
    symbol() {
      return this.$route.query.symbol
    },
    sliceShareholderList() {
      return this.isMore ? this.shareholderList : this.shareholderList.slice(0, 5)
    }
  },
  created() {
    this.getShareholderList()
  },
  methods: {
    postcssPatch,
    async getShareholderList() {
      this.loading = true
      const res = await this.$post(this.$api.f10.hk + '/summary/major-shareholders', {
        symbol: this.symbol
      })
      const data = res.data ?? []
      this.shareholderList = data.sort((a, b) => b.holdingRatio - a.holdingRatio).slice(0, 10)
      this.finished = true
      this.loading = false
    }
  }
}
</script>

<style lang="scss" scoped>
.major-table {
  --table-tbody-font-size: 13px;
}
</style>
